import { Component } from '@angular/core';

@Component({
  selector: 'app-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.css']
})
export class FeesComponent {

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-secondary',
      desc: 'Courier Charges',
      route: '/logistics/fees/courier',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-secondary',
      //desc: 'T2D Charges',
      desc: 'Task Runner',
      route: '/logistics/fees/task',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-secondary',
      desc: 'Volume Charges',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-secondary',
      desc: 'Weight Charges',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-secondary',
      desc: 'Surcharges',
      route: '/logistics/fees/surcharges',
    },
  ];

  ngOnInit(): void {
    console.log('resumenCards',this.resumenCards)
  }


}
